import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap";
import startIcon from "../../../../assets/reports/star.svg";
import columnSelectorIcon from "../../../../assets/icon/column-selector.svg";
import closeIcon from "../../../../assets/icon/chatClose.svg";
import ArrowRight from "../../../../assets/icon/arrow-right-purple.svg";
import ListOverLay from "./ListOverlay";
import leftArrow from "../../../../assets/icon/left-arrow.svg";
import { useNavigate } from "react-router-dom";

const AllReports = () => {
  const [listOverLay, setListOverLay] = useState(false);
  const [data, setData] = useState();
  const [rSelected, setRSelected] = useState("off");
  const navigate = useNavigate();
   const [tableData, setTableData] = useState(rowData);
        const [dataRow, setDataRow] = useState([]);

  const columnData = [
    {
      dataField: "favorite",
      text: "Favorite",
      show: true,
      width: 20,
    },
    {
      dataField: "reportname",
      text: "Report Name",
      show: true,
      sort: true,
    },
    {
      dataField: "description",
      text: "Description",
      show: true,
      sort: true,
      width: 200,
    },
  ];

  const rowData = [
    {
      id: 1,
      favorite: <img src={startIcon} />,
      reportname: "Billing Accuracy Audit",
      description:
        "Review submitted claims for errors, such as incorrect codes or missing data",
    },
    {
      id: 2,
      favorite: <img src={startIcon} />,
      reportname: "Claims Reconcillation Report",
      description:
        "Matches submitted claims with received reimbursements to identify",
    },
    {
      id: 3,
      favorite: <img src={startIcon} />,
      reportname: "Copay Utilization Report",
      description:
        "Tracks copay amounts across all patients and highlights significant variations",
    },
    {
      id: 4,
      favorite: <img src={startIcon} />,
      reportname: "Patient Billing Summary",
      description:
        "Summarizes balances and payments for individual patients or families",
    },
    {
      id: 5,
      favorite: <img src={startIcon} />,
      reportname: "Rejction Trends Analysis",
      description:
        "Analyze claims denials to identify recurring issues by payer, drug",
    },
    {
      id: 6,
      favorite: <img src={startIcon} />,
      reportname: "Audit Trail Summary",
      description:
        "Captures system activities, including prescription edits, user logins, and overrides",
    },
    {
      id: 7,
      favorite: <img src={startIcon} />,
      reportname: "Controlled Substance Dispensing",
      description:
        "Details the dispensing of controlled substances in a given period",
    },
    {
      id: 8,
      favorite: <img src={startIcon} />,
      reportname: "PDMP Report Generator",
      description:
        "Generates state-specific, compliant PDMP files with customizable options",
    },
    {
      id: 9,
      favorite: <img src={startIcon} />,
      reportname: "Net Margin Tracker",
      description:
        "$ 2554.5Tracks pharmacy profitability after accounting for inventory costs",
    },
    {
      id: 10,
      favorite: <img src={startIcon} />,
      reportname: "Profitability by Drug Class ",
      description:
        "Analyzes profitability for each drug class, identifying the most and least",
    },
    {
      id: 10,
      favorite: <img src={startIcon} />,
      reportname: "Reimbursement Analysis ",
      description:
        "Identifies variances between claim-reported payment amounts",
    },
  ];

  const handleRowClick = (row) => {
    setListOverLay(true);
    setData(row);
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };
  return (
    <div className="table-card rep-res scroll-table position-relative border-0 pt-0 rounded bg-white">
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Drug Name"}
              data={rowData}
              setFilterData={setTableData}
            />
          </div>
          <div>
            <Dropdown isOpen={undefined} toggle={undefined} className="clmn">
              <DropdownToggle>
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                </span>
              </DropdownToggle>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className="d-flex">
          <Button color="primary">Create a New Report</Button>
        </div>
      </div>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="purchase-receive-orders"
          columns={columnData}
          data={rowData}
          setListOverLay={setListOverLay}
          enablerowRouting={true}
          handleRowClick={handleRowClick}
        />
      </div>
      <div>
        <Offcanvas
          isOpen={listOverLay}
          toggle={() => setListOverLay(!listOverLay)}
          direction="end"
        >
          <div className="casvas-header p-3 pb-2">
            <div className="d-flex justify-content-center align-items-center gap-4">
              {" "}
              <div className="d-flex justify-content-center align-items-center gap-4">
                {" "}
                <div
                  className="heading-text cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  <img src={leftArrow} className="cursor-pointer left-arrow-btn" /> Billing Accuracy Audit
                </div>
              </div>
            </div>
            <div onClick={() => setListOverLay(false)}>
              <img className="cursor-pointer" src={closeIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup"></div>
          <OffcanvasBody className="p-3 pt-2">
            <ListOverLay data={data} />
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </div>
  );
};

export default AllReports;
